import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dialog", "panel"]

  open() {
    this.dialogTarget.showModal()
  }

  close() {
    if (this.dialogTarget.open) {
      this.dialogTarget.close()
    }
  }

  backdropClick(event) {
    if (event.target === this.dialogTarget) {
      this.close()
    }
  }
}
